import { invokeAuthenticatedRuntime } from './runtime-worker-client';
import { supabase } from '@/lib/supabase';
import { toDashboardUiError } from './dashboard-errors';
import type {
  AccountTaskActionRequest,
  AccountTaskActionResponse,
  AccountTaskPlanRequest,
  AccountTaskPlanResponse,
} from '@shared/types/task-actions';


export const invokeTaskAction = async (body: Record<string, unknown>) => {
  const url = import.meta.env.VITE_TASK_ACTION_URL;
  if (typeof url === 'string' && url.trim()) return invokeAuthenticatedRuntime(url, body);
  const { data, error } = await supabase.functions.invoke('task-action', { body });
  if (error) throw new Error((await toDashboardUiError(error, 'Le travail n’a pas abouti.')).message);
  return data as unknown;
};

export const executeAccountTaskAction = async (
  input: AccountTaskActionRequest
): Promise<AccountTaskActionResponse> => {
  const data = await invokeTaskAction({ ...input });
  if (!data || typeof data !== 'object' || !('status' in data) || typeof data.status !== 'string') {
    throw new Error('La réponse de l’action est invalide.');
  }
  return data as AccountTaskActionResponse;
};

export const prepareAccountTaskPlan = async (
  input: AccountTaskPlanRequest
): Promise<AccountTaskPlanResponse> => {
  const data = await invokeTaskAction({ ...input });
  if (!data || typeof data !== 'object' || !('status' in data) || typeof data.status !== 'string') {
    throw new Error('La réponse de préparation est invalide.');
  }
  return data as AccountTaskPlanResponse;
};
